import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { API_BASE_URL, authHeaders, getSession } from "./apiConfig";
import { MENU } from "./menuConfig";

const AdminPanel = () => {
  const session = getSession();
  const [viewableScreens, setViewableScreens] = useState(null); // null = still loading

  useEffect(() => {
    if (!session?.token) {
      setViewableScreens(new Set());
      return;
    }
    fetch(`${API_BASE_URL}/permission/my`, { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => {
        const allowed = new Set(rows.filter((r) => r.canView).map((r) => r.screenKey));
        setViewableScreens(allowed);
      })
      .catch(() => setViewableScreens(new Set()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Flat list of individual pages the user can actually open - same MENU data
  // the sidebar uses, filtered by the same permission check.
  const accessibleLinks =
    viewableScreens === null
      ? null
      : MENU.flatMap((sec) =>
          sec.items
            .filter((item) => item.to && item.screenKey && viewableScreens.has(item.screenKey))
            .map((item) => ({ ...item, section: sec.section }))
        );

  return (
    <AdminLayout>
      <style>{`
        .dash-heading { margin: 0 0 1.25rem 0; font-size: 1.4rem; color: #0f172a; }

        .link-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 0.9rem; }
        .link-card {
          background: white; border: 1px solid #e2e8f0; border-radius: 10px;
          padding: 1rem 1.1rem; text-decoration: none; color: inherit;
          transition: box-shadow 0.15s, transform 0.15s;
          display: block; box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        }
        .link-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.1); transform: translateY(-2px); }
        .link-card-section { font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.04em; color: #94a3b8; margin-bottom: 4px; }
        .link-card-label { font-weight: 600; font-size: 0.95rem; color: #0f172a; }

        .tile-empty { color: #94a3b8; font-size: 0.875rem; padding: 1rem 0; }
      `}</style>

      <h1 className="dash-heading">Welcome{session?.User_Name ? `, ${session.User_Name}` : ""}</h1>

      <div className="link-grid">
        {viewableScreens === null ? (
          <p className="tile-empty">Loading your permissions...</p>
        ) : accessibleLinks.length === 0 ? (
          <p className="tile-empty">Your role doesn't have access to any pages yet. Contact an administrator.</p>
        ) : (
          accessibleLinks.map((item) => (
            <Link key={`${item.section}-${item.label}`} to={item.to} className="link-card">
              <div className="link-card-section">{item.section}</div>
              <div className="link-card-label">{item.label}</div>
            </Link>
          ))
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminPanel;